import PublicLayout from "./public.layout";
export default PublicLayout;
